module.exports = __webpack_public_path__ + "static/media/sq_grab.96d779b7.png";